import React from 'react'
import { CellCompProps } from 'src/components/Table/Table'

const AcudaCell = <T extends {}> ({ row, col }: CellCompProps<T>) => {
  const val = row[col.name]
  return (
    <div className={`cell ${col.name}`}>
      {val === 'SI' &&
        <span className="acuda-tag">SAT</span>
      }
    </div>
  )
}

export default AcudaCell
